import { ROUTES } from '@analyzer/utils/router/paths'
import { UserProvider } from '@core/components/user-provider/UserProvider'
import { useAuthStore } from '@core/stores/auth-store'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

function AuthenticatedLayout() {
  return (
    <UserProvider>
      <Outlet />
    </UserProvider>
  )
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    if (!useAuthStore.getState().isLogged()) {
      throw redirect({ to: ROUTES.signIn })
    }
  },
  component: AuthenticatedLayout,
})
